import React from 'react'

import Head from 'next/head'

type FaqProps = {
    content: string
}

const Faq = ({ content }: FaqProps): JSX.Element | null => {
    if (!process.browser) return null
    const tempElement = document.createElement('DIV')
    tempElement.innerHTML = content

    const data = tempElement.getElementsByClassName('faq-schema-content')
    const schemaData = []
    for (let i = 0; i < data.length; i++) {
        const tempInnerElement = document.createElement('DIV')
        tempInnerElement.innerHTML = data[i]?.innerHTML

        const questionData = tempInnerElement.getElementsByClassName(
            'faq-schema-question'
        )
        const answerData = tempInnerElement.getElementsByClassName(
            'faq-schema-answer'
        )
        if (questionData.length > 0 || answerData.length > 0) {
            schemaData.push({
                '@type': 'Question',
                name: questionData ? questionData[0]?.textContent : '',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: answerData ? answerData[0]?.textContent : ''
                }
            })
        }
    }

    const faqData = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: schemaData
    }

    return schemaData.length > 0 ? (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(faqData, null, '\t')
                }}
            />
        </Head>
    ) : null
}

export default Faq
